// extracted by mini-css-extract-plugin
export default {"border_none":"CountryProfile_border_none__bFucS","text_noWrap":"CountryProfile_text_noWrap__84ruN"};